import './sentry'
import { StrictMode } from 'react'
import { createRoot }  from 'react-dom/client'
import App from './App.jsx'
import { Sentry } from './sentry'

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <Sentry.ErrorBoundary fallback={<p>Something went wrong. We've been notified.</p>}>
      <App />
    </Sentry.ErrorBoundary>
  </StrictMode>
)
